module.exports = __webpack_public_path__ + "img/achievement_12.9de90e1c.png";